<template>
  <div class="AssetCategoryView">
    <ATable
      ref="table"
      size="mini"
      class="no-pointer"      
      max-height="684px"
      :data="items"
      :spanMethod="handleSpanMethod"
      border
      hide-button-insert
      hide-pagination
    >
      <el-table-column
        type="index"
        label="No"          
        :width="$width.indexw"
        :index="handleIndex"
      />
      <el-table-column 
        prop="type_name" 
        label="구분" 
        width="80" 
        align="center"
      />
      <el-table-column 
        prop="parent_name" 
        label="주계정명" 
      />
      <el-table-column 
        prop="name" 
        label="부계정명" 
      />
    </ATable>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { base_data } from "@/common/mixins/base_data";

export default {
  name: "AssetCategoryView",
  mixins: [base_data],
  data() {
    return {
      title: this.$t("title.asset_category"),
      items: [],
      hashType: {},     //rowspan하기 위해 구분 갯수를 저장
      hashParent: {},   //rowspan하기 위해 주계정 갯수를 저장
      loading: false,
      base_data: ['table_asset_category']
    };
  },  
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters(["table_asset_category"]),
    columns() {
      return this.$refs.table.columns;
    },
  },
  methods: {
    init() {     
      this.loading = true;
      let items = [];      
      items.push(...this.typeItems(1));
      items.push(...this.typeItems(2));
      this.items = items;
      this.loading = false;
    },
    typeItems(type_id) {
      let items = [];
      let type_name = type_id === 1 ? '수입' : '지출';
      let parents = this.parentItems(type_id);
      if (parents.length < 1) {
        return [{ 
          type_id: type_id,
          type_name: type_name,
        }];
      }
      parents.forEach(p => {
        let children = this.childItems(p.id);
        if (children.length < 1) {
          items.push({ 
            type_id: type_id,
            type_name: type_name, 
            parent_id: p.id,
            parent_name: p.name, 
          });
        } else {
          children.forEach(c => {
            items.push({ 
              type_id: type_id,
              type_name: type_name, 
              parent_id: p.id,
              parent_name: p.name, 
              id: c.id,
              name: c.name,
            });
          })
        }
      });
      return items;
    },
    parentItems(type_id) {      
      return this.table_asset_category.filter(c => {
        return c.type_id === type_id && !c.parent_id
      }).sort(this.util.sortByName);
    },
    childItems(parent_id) {
      return this.table_asset_category.filter(c => {
        return c.parent_id === parent_id
      }).sort(this.util.sortByName);
    },
    comparePrevRow(rowIndex, columnIndex) {
      if (rowIndex === 0) {
        return false;
      }
      let colName = this.columns[columnIndex].property;
      if (
        this.items[rowIndex - 1][colName] !==
        this.items[rowIndex][colName]
      ) {
        return false;
      }
      return true;
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleSpanMethod({ row, rowIndex, columnIndex }) {
      if (![1, 2].includes(columnIndex)) { return; }
      if (this.comparePrevRow(rowIndex, columnIndex)) {
        return { rowspan: 0, colspan: 0 };
      } 
      let items = []
      if (columnIndex === 1) {
        items = this.items.filter(item => item.type_id === row.type_id);
      } else {
        items = this.items.filter(item => item.parent_id === row.parent_id);
      }
      return { 
        rowspan: items.length ? items.length : 1, 
        colspan: 1 
      }
    },
  }
};
</script>
